<main class="dialog-body">

  <!-- Header -->
  <div class="dialog-header">
    <div class="dialog-header-text">Assign Students</div>
    <div class="cross-icon" (click)="onCancel()" [class.disabled]="isSubmitting">
      <img src="assets/images/cross-icon.svg" class="cross-icon-img" alt="close" />
    </div>
  </div>

  <mat-dialog-content class="dialog-content">

    <!-- Search zone: always anchored at top -->
    <div class="search-zone">

      <!-- Search + Add new -->
      <div class="top-row">
        <div class="search-bar">
          <img src="assets/images/search-icon.svg" alt="search" class="search-icon" />
          <input
            type="text"
            placeholder="Search student.."
            [(ngModel)]="searchQuery"
            class="search-input"
          />
        </div>
        <button
          class="add-new-btn"
          type="button"
          (click)="openAddNewStudent()"
          [disabled]="isSubmitting"
        >
          + Add new student
        </button>
      </div>

      <!-- Loading -->
      <div *ngIf="isLoading" class="state-message">Loading students...</div>

      <!-- Search results (only shown when user is typing, max 5 rows) -->
      <div *ngIf="!isLoading && isSearching" class="student-list">
        <div *ngFor="let student of availableStudents" class="student-row" (click)="addStudent(student)">
          <span class="student-name">{{ student.fullName }}</span>
          <button class="add-btn" type="button" (click)="$event.stopPropagation(); addStudent(student)" [disabled]="isSubmitting">+</button>
        </div>
        <div *ngIf="availableStudents.length === 0" class="state-message">
          No students match "{{ searchQuery }}"
        </div>
      </div>

    </div>

    <!-- Assigned students section: always visible below search -->
    <div class="assigned-section" *ngIf="assignedStudents.length > 0">
      <div class="assigned-label">Assigned students <span class="assigned-count">({{ assignedStudents.length }})</span></div>
      <div class="assigned-chips">
        <div *ngFor="let student of assignedStudents" class="chip">
          <span class="chip-name">{{ student.fullName }}</span>
          <button
            class="chip-remove"
            type="button"
            (click)="removeStudent(student)"
            [disabled]="isSubmitting"
          >×</button>
        </div>
      </div>
    </div>

  </mat-dialog-content>

  <!-- Footer -->
  <mat-dialog-actions class="action-buttons">
    <span class="selected-count">
      <strong>{{ assignedStudents.length }}</strong>
      {{ assignedStudents.length === 1 ? 'student' : 'students' }} selected
    </span>
    <div class="button-group">
      <button
        class="dialog-button cancel-button"
        (click)="onCancel()"
        [disabled]="isSubmitting"
      >
        Cancel
      </button>
      <button
        class="dialog-button submit-button"
        (click)="onSubmit()"
        [disabled]="isSubmitting || assignedStudents.length === 0"
      >
        <span *ngIf="!isSubmitting">Assign Students</span>
        <span *ngIf="isSubmitting" class="submit-loading">
          <span class="spinner"></span>
          Assigning...
        </span>
      </button>
    </div>
  </mat-dialog-actions>

</main>
